module.exports = __webpack_public_path__ + "static/img/cloud-right-top-min.eef755d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/cloud-right-top-min.png
// module id = 658
// module chunks = 64